import { SidebarItem, SidebarLink } from "@/types/types";

export const SidebarGenerator = (items: SidebarLink[]): SidebarItem[] => {
  return items.map(({ icon, label, path, isNew,isExternalRedirect }) => ({
    icon,
    label,
    path: `/${path}`,
    isExternalRedirect,

    isNew,
  }));
};
